import { useAppCtx, appStore } from "lib/state"
import { queryTools } from "lib/utils"

export default function useApiData() {

  const { store, AppStore }:any = appStore()

  const { update }:any = AppStore

  const { data:_ApiData } = queryTools.resource.parseQueryForApi("apidata.findAll", {})
  const { data:_ApiDataItem } = queryTools.resource.parseQueryForApi("apidata.findById", { _id: store.actives.apidata?._id })

  /**
   * Puts the item into apiData.selectedItem
   * @param item 
   */
  function selectItem(item:any){
    update("actives.apidata", item)
  }

  function sortResults(results:any){
    return results.sort( (a:any, b:any) => {
      if( a.label < b.label ) return -1
      if( a.label > b.label ) return 1
      return
    })
  }

  function sortResults2(results:any){
    return results.sort( (a:any, b:any) => {
      if( a.path.split(".")[a.path.length-1] < b.path.split(".")[b.path.length-1] ) return -1
      if( a.path.split(".")[a.path.length-1] > b.path.split(".")[b.path.length-1] ) return 1
      return
    })
  }

  function addExtraFilters(results:any[]){
    return results.filter((item:any) => 
      item.label?.length > 0
      && !item.path.includes("{Object}")
      && item.type !== "object"
      && item.type !== "array"
    )
  }

  function getItemsBySegment({path="", segment=""}:{ path:string; segment?:string}){
    if( !path.length ) path = "rp"
    if( !segment.length ){
      console.log("here")
      const firstResults = _ApiData?.filter((item:any) => item.path.startsWith(path) )
      return sortResults(addExtraFilters(firstResults))
    } else {
      console.log(`${path}.${segment}`)
      const firstResults = _ApiData?.filter((item:any) => item.path.startsWith(`${path}.${segment}`) )
      return sortResults(addExtraFilters(firstResults))
    }
  }

  // function getDirectChildren(path:string, collection:any[]){
  //   // console.log(collection)
  //   const filtered = collection.filter( (item:any) => item.parent === path )

  //   const parentItems = filtered.filter( (item:any) => item.hiddenType === "array" || item.hiddenType === "object" )
  //   const parentItemsSorted = parentItems.sort( (a:any, b:any) => {
  //     if( a.label < b.label ) return -1
  //     if( a.label > b.label ) return 1
  //     return 0
  //   } )

  //   const orphans = filtered.filter( (item:any) => item.hiddenType !== "array" && item.hiddenType !== "object" )
  //   const orphansSorted = orphans.sort( (a:any, b:any) => {
  //     if( a.label < b.label ) return -1
  //     if( a.label > b.label ) return 1
  //     return 0
  //   } )

  //   return [
  //     ...orphansSorted,
  //     ...parentItemsSorted
  //   ]
  // }


  return  {
    getItemsBySegment,
    selectItem
  }
}